import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { NotionalCounterDetail, NotionalInput } from 'src/app/Models/ops';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';

@Component({
  selector: 'app-spra-notional-input',
  templateUrl: './spra-notional-input.component.html',
  styleUrls: ['./spra-notional-input.component.css']
})
export class SpraNotionalInputComponent implements OnInit {
  public NotionalInput:NotionalInput;
  public utility: Utility;
  public FromView:boolean=false;
  constructor(private dialogRef: MatDialogRef<SpraNotionalInputComponent>,    
    @Inject(MAT_DIALOG_DATA) public data:any,
    private cookieService: CookieService,
    private _NotificationService: NotificationService
    ) { 
      this.utility = new Utility(this.cookieService);
      this.NotionalInput = new NotionalInput();            
    }

  ngOnInit(): void {
    if(this.data != undefined ){
      this.NotionalInput = this.data._NotionalInput;
      //Added by rahul yadav on 16/7/2021 in case of view
      if(this.data.FromView!=undefined){
        this.FromView = this.data.FromView;
      }
    }else{
      this.NotionalInput.CounterDetail.push(new NotionalCounterDetail());
    }

  }


  Close(){
    this.RateCommitmentChange();
   if(!this.utility.CheckNumberRequired(this.NotionalInput.Rent)){
    this._NotificationService.showError("Calculated Rent can not be Zero.", "Notional Rent Detail");     
   }else{
    this.dialogRef.close({ event: 'Close', data: {NotionalInput:this.NotionalInput}});
   }

    
  }

RateCommitmentChange(){  
  this.NotionalInput.Rent = this.utility.RoundOff(this.NotionalInput.CounterDetail.map(cd => (cd.Rate*cd.Commitment)).reduce((sum, current) => sum + current, 0),0);

}


}
